// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0f60db11","455":"df08919b","977":"08a1dc92"}[chunkId] + ".chunk.js";
};